<template>
  <div v-if="errors">
    <div v-for="(error, index) in errors" :key="index" class="form__error">
      {{ error }}
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  errors: {
    type: Object,
    required: true,
  },
});

const errors = computed(() => props.errors);
</script>
